// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__iu4do","filesListContainer":"PosDisputesFiles_filesListContainer__vhred","filesButton":"PosDisputesFiles_filesButton__3zrKo"};